"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterOperation = exports.useFilters = void 0;
const common_types_1 = require("../../common-types");
const react_1 = require("react");
const lodash_1 = require("lodash");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
function useFilters({ source, filtersFields, preFilters, sorts, }) {
    /**
     * Inner state of filter form.
     */
    const [filters, setFilters] = (0, react_1.useState)(() => {
        var _a, _b;
        const defaultFilters = (_b = (_a = source.getParams()) === null || _a === void 0 ? void 0 : _a.filters) !== null && _b !== void 0 ? _b : [];
        const initState = filtersFields.map((f) => {
            var _a, _b, _c;
            const defaultFilter = defaultFilters === null || defaultFilters === void 0 ? void 0 : defaultFilters.find((filter) => filter.field === f.filterkey);
            return {
                field: f.filterkey,
                operation: (_b = (_a = defaultFilter === null || defaultFilter === void 0 ? void 0 : defaultFilter.operation) !== null && _a !== void 0 ? _a : f.defaultOperation) !== null && _b !== void 0 ? _b : common_types_1.ApiFilterOperation.CONTAINS,
                asciiFolding: false,
                path: (_c = defaultFilter === null || defaultFilter === void 0 ? void 0 : defaultFilter.path) !== null && _c !== void 0 ? _c : f.path,
                value: defaultFilter === null || defaultFilter === void 0 ? void 0 : defaultFilter.value,
                object: defaultFilter === null || defaultFilter === void 0 ? void 0 : defaultFilter.object,
                filters: defaultFilter === null || defaultFilter === void 0 ? void 0 : defaultFilter.filters,
            };
        });
        return initState;
    });
    const validFilters = (0, react_1.useMemo)(() => filters
        .filter((f) => { var _a; return !!f.value || ((_a = f.object) === null || _a === void 0 ? void 0 : _a.length); })
        .map((f) => ({
        field: f.field,
        operation: f.operation,
        visible: f.visible,
        asciiFolding: f.asciiFolding,
        path: f.path,
        value: f.value,
        object: f.object,
        filters: f.filters,
    })), [filters]);
    /**
     * Reset filters and source into init state.
     */
    const reset = (0, event_callback_hook_1.useEventCallback)(() => {
        setFilters(filtersFields.map((f) => {
            var _a;
            return ({
                field: f.filterkey,
                operation: (_a = f.defaultOperation) !== null && _a !== void 0 ? _a : common_types_1.ApiFilterOperation.CONTAINS,
                path: f.path,
            });
        }));
        source.setParams({ filters: preFilters, sort: sorts !== null && sorts !== void 0 ? sorts : [] });
        source.reset();
        source.loadMore();
    });
    /**
     * Changes the value of the filter.
     */
    const handleFilterValueChange = (0, event_callback_hook_1.useEventCallback)((index, value) => {
        setFilters((filters) => [
            ...filters.slice(0, index),
            { ...filters[index], visible: true, value },
            ...filters.slice(index + 1),
        ]);
    });
    /**
     * Changes the state of the filter.
     */
    const handleFilterStateChange = (0, event_callback_hook_1.useEventCallback)((index, state) => {
        setFilters((filters) => [
            ...filters.slice(0, index),
            state,
            ...filters.slice(index + 1),
        ]);
    });
    /**
     * Derives nested filters.
     */
    const deriveNestedFilters = (filters) => {
        const NON_NESTED = 'NON_NESTED';
        const derivedFilters = [];
        const groupedFilters = (0, lodash_1.groupBy)(filters, (filter) => { var _a; return (_a = filter === null || filter === void 0 ? void 0 : filter.path) !== null && _a !== void 0 ? _a : NON_NESTED; });
        (0, lodash_1.keys)(groupedFilters).forEach((path) => {
            var _a;
            if (path === NON_NESTED) {
                derivedFilters.push(...((_a = groupedFilters === null || groupedFilters === void 0 ? void 0 : groupedFilters[NON_NESTED]) !== null && _a !== void 0 ? _a : []));
            }
            else {
                derivedFilters.push({
                    operation: common_types_1.ApiFilterOperation.NESTED,
                    path,
                    filter: {
                        operation: common_types_1.ApiFilterOperation.AND,
                        filters: groupedFilters[path],
                    },
                });
            }
        });
        return derivedFilters;
    };
    /**
     * Sets params to source.
     */
    const search = (0, event_callback_hook_1.useEventCallback)(() => {
        const params = source.getParams();
        const derivedFilters = deriveNestedFilters(validFilters);
        source.setParams({
            ...params,
            filters: [...derivedFilters, ...preFilters],
        });
        source.reset();
        source.loadMore();
    });
    return {
        filters,
        reset,
        handleFilterValueChange,
        handleFilterStateChange,
        search,
        validFilters,
    };
}
exports.useFilters = useFilters;
function useFilterOperation(state, onChangeState) {
    const handleChangeOperation = (0, event_callback_hook_1.useEventCallback)((operation) => {
        if (operation) {
            onChangeState({
                ...state,
                operation: operation,
            });
        }
    });
    return { handleChangeOperation };
}
exports.useFilterOperation = useFilterOperation;
//# sourceMappingURL=field-filter-hook.js.map